/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from '@/components/BottomNav';
export default {
  components: {
    BottomNav: BottomNav
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {
    // 问题反馈
    feedback: function feedback() {
      this.$router.push({
        name: 'Feedback'
      });
    },
    // 问题处理
    problemHandling: function problemHandling() {
      this.$router.push({
        name: 'ProblemHandling'
      });
    }
  }
};